import { render, staticRenderFns } from "./PanicAlertDataTable.vue?vue&type=template&id=4879a6d8"
import script from "./PanicAlertDataTable.vue?vue&type=script&lang=js"
export * from "./PanicAlertDataTable.vue?vue&type=script&lang=js"
import style0 from "./PanicAlertDataTable.vue?vue&type=style&index=0&id=4879a6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports